import Actions from '../actions/actions';
import {
  retrieved,
  setBusy,
  setUnBusy,
  deleteLocalFirst,
} from './common/commonReducers';
import _ from 'lodash';
import { AdAudiencesState } from '../interfaces/adAudiences';
import adAudienceCRUDActions from '../actions/AdAudienceCRUDActions';
import AdAudienceModel from '../model/AdAudienceModel';

const initialState: AdAudiencesState = {
  busy: false,
  entities: [],
};

const checkIfIdUnique = (
  prevItem: AdAudienceModel,
  nextItem: AdAudienceModel,
) => prevItem.id === nextItem.id;

const unionUniqueById = (
  prevEntities: AdAudienceModel[],
  nextEntities: AdAudienceModel[],
) => {
  return _.unionWith(prevEntities, nextEntities, checkIfIdUnique);
};

const retrievedAll = (state: AdAudiencesState, action): AdAudiencesState => {
  const { entities: nextEntities } = action;
  const { entities: prevEntities } = state;

  return {
    ...state,
    entities: unionUniqueById(prevEntities, nextEntities),
    busy: false,
  };
};
export default function adAudiences(
  state: AdAudiencesState = initialState,
  action,
): AdAudiencesState {
  switch (action.type) {
    case adAudienceCRUDActions.retrievedAction:
      return retrieved(state, action);
    case adAudienceCRUDActions.busyAction:
      return setBusy(state);
    case adAudienceCRUDActions.deleteLocalAction:
      return deleteLocalFirst(state, action);
    case adAudienceCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case adAudienceCRUDActions.unbusyAction:
      return setUnBusy(state);
    case adAudienceCRUDActions.resetAction:
    case Actions.RESET:
      return initialState;
    default:
      return state;
  }
}
